import { render, staticRenderFns } from "./AccessSucceedCard.vue?vue&type=template&id=20694fd3&scoped=true"
import script from "./AccessSucceedCard.vue?vue&type=script&lang=js"
export * from "./AccessSucceedCard.vue?vue&type=script&lang=js"
import style0 from "./AccessSucceedCard.vue?vue&type=style&index=0&id=20694fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20694fd3",
  null
  
)

export default component.exports